export default () => /Edge\//.test(navigator.userAgent);
